import React, {useContext} from 'react';
import LoginForm from './LoginForm'
import {StateContext} from "./State";
import './themes/default';
import './App.scss';
import 'animate.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './themes/default/toast.css'

const App = () => {
    const [, dispatch] = useContext(StateContext);

    const onLogin = (v) => {
        dispatch({type: 'auth', payload: v})
    };

    return <>
        <img src="logos/banner.png" id="banner" alt={"Flow WMS"}/>
        <LoginForm loginAction={onLogin}/>
        <ToastContainer />
    </>
}

export default App;